import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchSection() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
          {t('search.h2')}
        </h2>
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t('search.placeholder')}
            className="flex-1 px-4 py-3 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
          />
          <button
            onClick={() => {
              if (query.trim()) {
                window.open(`https://kaspreadsheet.com/search?q=${encodeURIComponent(query)}`, '_blank', 'noopener,noreferrer');
              }
            }}
            className="px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('search.button')}
          </button>
        </div>
        <p className="mt-4 text-sm text-foreground-500">
          <span className="font-medium">{t('search.popular')}</span> {t('search.tags')}
        </p>
      </div>
    </section>
  );
}